ux-chat {
  display: flex;
  flex-direction: column;
  height: var(--ux-chat-height, 500px);
  min-height: 0;
  position: relative;
  box-sizing: border-box;
}

#chat-container {
  background-color: $color-blue-6;
  padding: 30px;
  flex: 1 1 0%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-anchor: none;

  &:has(ux-chat-typing-indicator) {
    scroll-behavior: smooth;
  }

  &.has-error {
    ux-modal {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      margin: 0;
    }

    .chat-error-icon {
      text-align: center;
      margin-bottom: 16px;

      ux-icon {
        font-size: 48px;
        color: $color-red;
      }
    }

    .chat-error-title {
      text-align: center;
      margin: 0 0 8px;
      font-size: 18px;
      font-weight: 600;
    }

    .chat-error-message {
      text-align: center;
      margin: 0 0 24px;
      color: $color-black;
    }

    .chat-error-actions {
      display: flex;
      justify-content: center;
      margin-top: 24px;

      ux-button {
        min-width: 120px;
      }
    }
  }
}

.chat-container__items {
  display: flex;
  flex-direction: column;
  gap: 18px 5px;
  margin: 0;
  justify-content: flex-start;
}

#chat-bar {
  position: relative;
  margin-top: 10px;
  background-color: $color-white;
  flex: 0 0 auto;
  box-sizing: border-box;
}

::slotted(ux-chat-item[source="user"]) {
  margin-bottom: 0;
  align-self: flex-end;
}
